import React from 'react';
import _ from 'lodash';

import { ATTACH_DOCUMENT_TYPE_COMPANY } from '../utilities/constants';
import {
  FormElement,
  FormListItem,
  FormListSubHeader,
} from './CommonFormComponents';
import { Description } from './Description';
import AttachDocument from './forms/AttachDocument';

export const OldAttachmentPermission = ({
  hasSecurityPermission = true,
  hasOtherIndustryPermission = true,
  companyDocuments,
  documentCodes,
  events,
  readOnly,
}) => {
  if (_.isEmpty(companyDocuments)) {
    return null;
  }
  return (
    <React.Fragment>
      <FormListSubHeader title='許可情報の添付書類' />
      <div className='form-list-default__ExceptionalItems'>
        <Description type='primary'>
          <React.Fragment>
            2022年3月27日以降、許可情報への添付書類の新規登録・更新が行えなくなりました。
            <br />
            現在は「
            <span
              className='clickable-text'
              onClick={() => {
                scrollToElem('CompanyLicenseInformation');
              }}
            >
              建設業許可情報
            </span>
            」
            {hasSecurityPermission && (
              <React.Fragment>
                「
                <span
                  className='clickable-text'
                  onClick={() => {
                    scrollToElem('CompanySecurityInformation');
                  }}
                >
                  警備業許可情報
                </span>
                」
              </React.Fragment>
            )}
            {hasOtherIndustryPermission && (
              <React.Fragment>
                「
                <span
                  className='clickable-text'
                  onClick={() => {
                    scrollToElem('CompanyOtherIndustryLicenseInformation');
                  }}
                >
                  その他許可情報
                </span>
                」
              </React.Fragment>
            )}
            ごとにファイルの添付が可能です。
            <br />
            すでに本項に登録済みのファイルについては、個別に添付しなおしてください。
            <br />
            本項は将来的に廃止を予定しているため、早めにファイルの再添付をお願いいたします。
          </React.Fragment>
        </Description>
      </div>
      <FormListItem label='許可証'>
        <FormElement>
          <AttachDocument
            companyDocuments={companyDocuments}
            documentCodes={_.filter(documentCodes, document => {
              return (
                document.file_typeL ===
                ATTACH_DOCUMENT_TYPE_COMPANY.CONSTRUCTION_PERMISSION
              );
            })}
            events={{
              ...events,
              deleteFile: events.deleteOldCompanyPermissionDocuments,
            }}
            readOnly={readOnly}
            deleteOnly={true}
            isFormListDefault={true}
          />
        </FormElement>
      </FormListItem>
    </React.Fragment>
  );
};
export const scrollToElem = elementId => {
  const elm = document.getElementById(elementId);
  if (elm) {
    elm.scrollIntoView({ behavior: 'smooth' });
  }
};



// WEBPACK FOOTER //
// ./src/components/OldAttachmentPermission.jsx